import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { shuffleArray } from "../../../../utils";
import Score0 from "./resources/Score0.png";
import Score1 from "./resources/Score1.png";
import Score2 from "./resources/Score2.png";
import Score3 from "./resources/Score3.png";
import Score4 from "./resources/Score4.png";
import Score5 from "./resources/Score5.png";
import Score6 from "./resources/Score6.png";
import Score7 from "./resources/Score7.png";
import Score8 from "./resources/Score8.png";
import "./MarblesPage.css";
import { ReactComponent as CircleSvg } from "../../../../SharedImages/Circle.svg";
import { ReactComponent as FlagSvg } from "../../../../SharedImages/Flag.svg";
import { ReactComponent as SkullSvg } from "../../../../SharedImages/Skull.svg";
import { GAME_OPTIONS_PATH } from "../../../../constants";

import { FIREBASE_AUTH } from "../../../../FirebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { updateProgress, useGrammarUnitData } from "../../../../database";

const BACKGROUND_IMAGES = [
  Score0,
  Score1,
  Score2,
  Score3,
  Score4,
  Score5,
  Score6,
  Score7,
  Score8,
];

function ScoreView() {
  return (
    <>
      <SkullSvg />
      <CircleSvg />
      <CircleSvg />
      <CircleSvg className="gray" />
      <CircleSvg />
      <CircleSvg />
      <CircleSvg />
      <CircleSvg />
      <FlagSvg />
    </>
  );
}

function MarblesPage() {
  const EASY_QUESTION_RESPONSE_TIME = 300000;
  const MEDIUM_QUESTION_RESPONSE_TIME = 20000;
  const HARD_QUESTION_RESPONSE_TIME = 10000;
  const location = useLocation();
  const { unit, category } = location.state;
  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(FIREBASE_AUTH, (user) => {
      setUser(user);
    });
  });

  const {
    data: grammarData,
    loading,
    error,
  } = useGrammarUnitData(unit.unit, unit.textbook);
  // console.log(grammarData);
  const [state, setState] = useState({
    questions: [],
    currQuestionIndex: 0,
    score: 3,
    radioButton: null,
    showErrorMessage: false,
    showCorrectMessage: false,
  });

  const openTutorial = () => {
    const pregameEl = document.getElementById("pregame");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");
    const gameEl = document.getElementById("game");

    if (pregameEl) pregameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "flex";
    if (postgameEl) postgameEl.style.display = "none";
    if (gameEl) gameEl.style.display = "none";
  };

  const closeTutorial = () => {
    const pregameEl = document.getElementById("pregame");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");

    if (pregameEl) pregameEl.style.display = "flex";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
  };

  // Update questions once grammarData is available
  useEffect(() => {
    if (grammarData.length > 0) {
      setState((prevState) => {
        // Prevent updating state if the data hasn't changed
        if (
          JSON.stringify(prevState.questions) !== JSON.stringify(grammarData)
        ) {
          console.log(grammarData);
          return {
            ...prevState,
            questions: grammarData,
          };
        }
        return prevState; // Return previous state if data is the same
      });
    }
  }, [grammarData, loading, state]); // Re-run only when grammarData or loading state changes

  const [remainingTime, setRemainingTime] = useState(
    state.questionResponseTime,
  );

  const handleOptionChange = (event) => {
    setState({ ...state, radioButton: event.target.value });
  };

  useEffect(() => {
    // Initialize question response time based on difficulty when the game starts
    const difficulty = document.querySelector(
      'input[name="difficulty"]:checked',
    );
    if (difficulty) {
      let initialQuestionResponseTime;
      if (difficulty.value === "easy") {
        initialQuestionResponseTime = EASY_QUESTION_RESPONSE_TIME;
      } else if (difficulty.value === "medium") {
        initialQuestionResponseTime = MEDIUM_QUESTION_RESPONSE_TIME;
      } else {
        initialQuestionResponseTime = HARD_QUESTION_RESPONSE_TIME;
      }

      setState((prevState) => ({
        ...prevState,
        questionResponseTime: initialQuestionResponseTime,
      }));

      // Set remaining time to initial question response time
      setRemainingTime(initialQuestionResponseTime);
    }
  }, [state.questions]); // Include state.questions as a dependency to re-run when the questions change

  function startGame() {
    const difficultyRadioButton = document.querySelector(
      'input[name="difficulty"]:checked',
    );

    if (!difficultyRadioButton) {
      alert("Please select a difficulty level before starting the game.");
      return;
    }

    const difficulty = difficultyRadioButton.value;

    // Safely hide pregame elements
    const pregameEl = document.getElementById("pregame");
    if (pregameEl) pregameEl.style.display = "none";

    const tutorialEl = document.getElementById("tutorial");
    if (tutorialEl) tutorialEl.style.display = "none";
    const helpButtonEl = document.getElementById("marbles-help-button");
    if (helpButtonEl) helpButtonEl.style.display = "none";

    const postgameEl = document.getElementById("postgame");
    if (postgameEl) postgameEl.style.display = "none";

    const winTextEl = document.getElementById("win-text");
    if (winTextEl) winTextEl.style.display = "none";

    const loseTextEl = document.getElementById("lose-text");
    if (loseTextEl) loseTextEl.style.display = "none";

    const questions = state.questions;
    shuffleArray(questions);
    setState({ ...state, questions: questions });

    let initialQuestionResponseTime;
    if (difficulty === "easy") {
      initialQuestionResponseTime = EASY_QUESTION_RESPONSE_TIME;
    } else if (difficulty === "medium") {
      initialQuestionResponseTime = MEDIUM_QUESTION_RESPONSE_TIME;
    } else {
      initialQuestionResponseTime = HARD_QUESTION_RESPONSE_TIME;
    }
    setState({ ...state, questionResponseTime: initialQuestionResponseTime });
    setRemainingTime(initialQuestionResponseTime);

    const scoreEl = document.getElementById("score");
    if (scoreEl) {
      const scoreChildren = scoreEl.childNodes;
      for (let i = 0; i < scoreChildren.length; i++) {
        scoreChildren[i].classList.remove("red", "green");
      }
      scoreEl.style.display = "flex";
    }

    const gameEl = document.getElementById("game");
    if (gameEl) gameEl.style.display = "flex";
  }

  useEffect(() => {
    let timer;
    const startTimer = () => {
      timer = setInterval(() => {
        setRemainingTime((prevTime) => Math.max(prevTime - 1000, 0));
      }, 1000);
    };

    startTimer();

    return () => {
      clearInterval(timer);
    };
  }, [state.currQuestionIndex, state.questionResponseTime]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const currScore = state.score;

      const gameElement = document.getElementById("game");
      if (gameElement && gameElement.style.display === "flex") {
        const newScore = currScore - 1;
        setState({ ...state, showErrorMessage: true });

        setTimeout(() => {
          if (newScore === 0) {
            const scoreEl = document.getElementById("score");
            if (scoreEl) scoreEl.childNodes[newScore].classList.add("red");

            if (gameElement) gameElement.style.display = "none";

            const postgameEl = document.getElementById("postgame");
            if (postgameEl) postgameEl.style.display = "flex";

            const loseTextEl = document.getElementById("lose-text");
            if (loseTextEl) loseTextEl.style.display = "flex";
          } else {
            if (newScore < 3) {
              const scoreEl = document.getElementById("score");
              if (scoreEl) scoreEl.childNodes[newScore].classList.add("red");
            } else if (newScore >= 3) {
              const scoreEl = document.getElementById("score");
              if (scoreEl)
                scoreEl.childNodes[newScore + 1].classList.remove("green");
            }
          }
          setState({
            ...state,
            radioButton: "",
            score: newScore,
            currQuestionIndex:
              (state.currQuestionIndex + 1) % state.questions.length,
            showErrorMessage: false,
          });
          setRemainingTime(state.questionResponseTime);
        }, 6000);
      }
    }, state.questionResponseTime);

    return () => clearTimeout(timeout);
  }, [state.currQuestionIndex, state.score, state.questionResponseTime]);

  function submitAnswer() {
    const questions = state.questions;
    const currQuestionIndex = state.currQuestionIndex;
    const isTrueFalse =
      questions[currQuestionIndex].choices.length > 0 ? false : true;
    const currScore = state.score;
    const submissionRadioButton = isTrueFalse
      ? document.querySelector('input[name="true_false"]:checked')
      : document.querySelector('input[name="multi_choice"]:checked');

    if (!submissionRadioButton) {
      alert("Please select an answer before submitting.");
      return;
    }

    const submission = submissionRadioButton.value;

    if (submission === questions[currQuestionIndex].answer) {
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "marble", true);
      }
      const newScore = currScore + 1;
      setState({ ...state, showCorrectMessage: true });
      if (newScore === 8) {
        const scoreEl = document.getElementById("score");
        if (scoreEl) scoreEl.childNodes[newScore].classList.add("green");

        const gameEl = document.getElementById("game");
        if (gameEl) gameEl.style.display = "none";

        const postgameEl = document.getElementById("postgame");
        if (postgameEl) postgameEl.style.display = "flex";

        const winTextEl = document.getElementById("win-text");
        if (winTextEl) winTextEl.style.display = "flex";
      } else {
        if (newScore <= 3) {
          const scoreEl = document.getElementById("score");
          if (scoreEl) scoreEl.childNodes[newScore - 1].classList.remove("red");
        } else if (newScore > 3) {
          const scoreEl = document.getElementById("score");
          if (scoreEl) scoreEl.childNodes[newScore].classList.add("green");
        }
      }
      setTimeout(() => {
        setState({
          ...state,
          radioButton: "",
          score: newScore,
          currQuestionIndex:
            (state.currQuestionIndex + 1) % state.questions.length,
          showCorrectMessage: false,
        });
        setRemainingTime(state.questionResponseTime);
      }, 2500);
    } else {
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "marble", false);
      }
      const newScore = currScore - 1;
      setState({ ...state, showErrorMessage: true });
      setTimeout(() => {
        if (newScore === 0) {
          const scoreEl = document.getElementById("score");
          if (scoreEl) scoreEl.childNodes[newScore].classList.add("red");

          const gameEl = document.getElementById("game");
          if (gameEl) gameEl.style.display = "none";

          const postgameEl = document.getElementById("postgame");
          if (postgameEl) postgameEl.style.display = "flex";

          const loseTextEl = document.getElementById("lose-text");
          if (loseTextEl) loseTextEl.style.display = "flex";
        } else {
          if (newScore < 3) {
            const scoreEl = document.getElementById("score");
            if (scoreEl) scoreEl.childNodes[newScore].classList.add("red");
          } else if (newScore >= 3) {
            const scoreEl = document.getElementById("score");
            if (scoreEl)
              scoreEl.childNodes[newScore + 1].classList.remove("green");
          }
        }
        setState({
          ...state,
          radioButton: "",
          score: newScore,
          currQuestionIndex:
            (state.currQuestionIndex + 1) % state.questions.length,
          showErrorMessage: false,
        });
        setRemainingTime(state.questionResponseTime);
      }, 6000);
    }
  }

  function playAgain() {
    setState({
      ...state,
      currQuestionIndex: 0,
      score: 3,
      radioButton: "",
    });

    const pregameEl = document.getElementById("pregame");
    if (pregameEl) pregameEl.style.display = "flex";

    const tutorialEl = document.getElementById("tutorial");
    if (tutorialEl) tutorialEl.style.display = "none";
    const helpButtonEl = document.getElementById("marbles-help-button");
    if (helpButtonEl) helpButtonEl.style.display = "flex";

    const gameEl = document.getElementById("game");
    if (gameEl) gameEl.style.display = "none";

    const postgameEl = document.getElementById("postgame");
    if (postgameEl) postgameEl.style.display = "none";

    const winTextEl = document.getElementById("win-text");
    if (winTextEl) winTextEl.style.display = "none";

    const loseTextEl = document.getElementById("lose-text");
    if (loseTextEl) loseTextEl.style.display = "none";
  }

  // Wait for questions to load and ensure they're not empty
  // console.log(state.questions);
  if (loading) {
    //  || state.questions.length === 0)
    return (
      <div className="loading-screen">
        <h2>Loading grammar questions...</h2>
      </div>
    );
  }

  // Show error message if data fetch failed
  if (error) {
    return (
      <div className="error-screen">
        <h2>Error loading grammar questions: {error}</h2>
      </div>
    );
  }

  return (
    <div id="marbles-full-container">
      <img id="background" src={BACKGROUND_IMAGES[state.score]} alt="Marbles" />
      <div id="empty-div"></div>
      <div id="marbles-container" style={{ paddingTop: "5em" }}>
        <div id="header">
          <button
            type="button"
            id="marbles-help-button"
            className="marbles-help-button"
            onClick={openTutorial}
            aria-label="Open Marbles tutorial"
          >
            ?
          </button>
          <h1>{unit.name}</h1>
          <div id="pregame">
            <div id="settings">
              <b>Difficulty Level:</b>
              <input
                type="radio"
                id="easy"
                value="easy"
                name="difficulty"
              ></input>
              <label for="easy">Easy</label>
              <input
                type="radio"
                id="medium"
                value="medium"
                name="difficulty"
              ></input>
              <label for="medium">Medium</label>
              <input
                type="radio"
                id="hard"
                value="hard"
                name="difficulty"
              ></input>
              <label for="hard">Hard</label>
              <br></br>
            </div>
            <button className="btn btn-primary" onClick={startGame}>
              Start Game
            </button>
          </div>
          <div id="game">
            <div id="score">
              <ScoreView />
            </div>
            <div id="question">
              {state.questions[state.currQuestionIndex].choices.length === 0 ? (
                <div>
                  <h2>Is the following grammatically true?</h2>
                </div>
              ) : (
                <h2>Choose an option to make it grammatically true</h2>
              )}
              <h2>
                <span id="question-text">
                  {state.questions[state.currQuestionIndex].question}
                </span>
              </h2>
            </div>
            <div>
              {state.questions[state.currQuestionIndex].choices.length === 0 ? (
                <div>
                  <input
                    type="radio"
                    name="true_false"
                    id="true"
                    value="true"
                    checked={state.radioButton === "true"}
                    onChange={handleOptionChange}
                  ></input>
                  <label for="true">True</label>
                  <input
                    type="radio"
                    name="true_false"
                    id="false"
                    value="false"
                    checked={state.radioButton === "false"}
                    onChange={handleOptionChange}
                  ></input>
                  <label for="false">False</label>
                </div>
              ) : (
                <div>
                  {/* {state.questions[state.currQuestionIndex].choices.map(
                    function (choice, i) {
                      return [
                        <input
                          type="radio"
                          name="multi_choice"
                          value={choice}
                          id={choice}
                          key={i}
                          checked={state.radioButton === choice}
                          onChange={handleOptionChange}
                        ></input>,
                        <label for={choice}>{choice}</label>,
                      ];
                    }
                  )} */}
                  {state.questions[state.currQuestionIndex].choices.map(
                    (choice, i) => (
                      <React.Fragment key={i}>
                        <input
                          type="radio"
                          name="multi_choice"
                          value={choice.text}
                          id={`choice-${i}`}
                          checked={state.radioButton === choice.text}
                          onChange={handleOptionChange}
                        />
                        <label htmlFor={`choice-${i}`}>{choice.text}</label>
                      </React.Fragment>
                    ),
                  )}
                </div>
              )}
            </div>
            <div id="answer">
              <button className="btn btn-primary" onClick={submitAnswer}>
                Submit
              </button>
            </div>
            <div id="timer-bar">
              <progress
                value={state.questionResponseTime - remainingTime}
                max={state.questionResponseTime}
              ></progress>
            </div>
            {/* Conditional Rendering within JSX: display error message if showErrorMessage is true */}
            {state.showErrorMessage && (
              <div id="error">
                <h2 id="error-message">Incorrect answer!</h2>
                <h3 id="error-message">
                  The right answer is :{" "}
                  {state.questions[state.currQuestionIndex].answer}
                </h3>
              </div>
            )}
            {state.showCorrectMessage && (
              <div id="correct">
                <h2 id="correct-message">Correct answer! Good job!</h2>
              </div>
            )}
          </div>
          <div id="postgame">
            <h2 id="win-text">Congratulations, you win!</h2>
            <h2 id="lose-text">Sorry, you lose. Better luck next time!</h2>
            <button className="btn btn-primary" onClick={playAgain}>
              Play Again
            </button>
          </div>
          <div id="tutorial">
          <h2>Marbles Tutorial</h2>
          <p>
            <b>Goal:</b> Fill the board with green progress markers by answering
            grammar questions correctly before you collect 3 red mistakes.
          </p>
          <p>
            <b>How to Play:</b>
            <br />
            1. Choose a difficulty level before starting.
            <br />
            2. Read the grammar prompt on the screen.
            <br />
            3. Choose either True/False or the best multiple-choice answer.
            <br />
            4. Submit your answer before the timer bar runs out.
          </p>
          <p>
            <b>Rules:</b>
            <br />
            Correct answers move your score toward the flag.
            <br />
            Wrong answers or timeouts move your score toward the skull.
            <br />
            You win when the board reaches the green end and lose after 3 red
            mistakes.
          </p>
          <p>
            <b>Difficulty:</b>
            <br />
            Harder levels shorten the timer for each question.
            <br />
            Watch the progress bar at the bottom so you do not run out of time.
          </p>
            <button className="btn btn-primary" onClick={closeTutorial}>
              Back to Game Setup
            </button>
          </div>
        </div>
        <Link
          to={GAME_OPTIONS_PATH}
          state={{ unit: unit, category: category }}
          className="game-options-back-link"
        >
          <button className="btn btn-back game-options-back-button">{"Back"}</button>
        </Link>
      </div>
    </div>
  );
}

export default MarblesPage;
